export function getStore(key) {
    let value = localStorage.getItem(key)
    if (value)
        return JSON.parse(value)
    return undefined
}
export function setStore(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
}

export function removeStore(key) {
    localStorage.removeItem(key)
}

export function clearStore() {
    const lang = localStorage.getItem(keys.lang)
    localStorage.clear()
    if (lang != null) localStorage.setItem(keys.lang, lang)
}

export const keys = {
    token: 'token',
    lang: 'lang',
    user: 'user',
    userInfo: 'userinfo',
    redirect: 'redirect',
    // IntercomUser:'IntercomUser'
}



// WEBPACK FOOTER //
// ./src/store/index.js